import {
  jb_anchor_css_default
} from "./chunk.TBFODQQH.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  Linkable
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-anchor/jb-anchor.ts
var JbAnchor = class extends Initiable(Linkable(i)) {
  constructor() {
    super(...arguments);
    this.flyPadding = "";
    this.forceHover = false;
    this.inactive = false;
  }
  getTextContent() {
    return this.innerText.trim();
  }
  render() {
    const classes = {
      inactive: !!this.inactive,
      hover: !!this.forceHover
    };
    return this.link?.href ? b`<a
          data-linkable
          class="${e(classes)}"
          .tabIndex=${this.inactive ? -1 : 0}
          part="anchor"
          data-fly-padding="${this.flyPadding ?? A}"
          aria-label="${this.ariaLabels?.label ?? A}"
          ><slot>${this.text}</slot></a
        >` : b`<span
          part="anchor"
          aria-label="${this.ariaLabels?.label ?? A}"
          ><slot>${this.text}</slot></span
        >`;
  }
};
JbAnchor.styles = [reset_css_default, jb_anchor_css_default];
__decorateClass([
  n({ type: Object })
], JbAnchor.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbAnchor.prototype, "flyPadding", 2);
__decorateClass([
  n({ type: Boolean })
], JbAnchor.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbAnchor.prototype, "inactive", 2);
__decorateClass([
  n()
], JbAnchor.prototype, "text", 2);
JbAnchor = __decorateClass([
  customElement("jb-anchor")
], JbAnchor);

export {
  JbAnchor
};
